import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { H3, H4, Breadcrumbs } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { getExpireSub } from "../../../CommonURL";
import { getDataWithToken } from "../../../Utils/restUtils";
import SearchList from "../../../CommonElements/Search";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import CompanyFilter from "../../Common/Filters/CompanyFilter";
import DatePicker from "react-datepicker";
import Transparentspinner from "../../Common/loader/Transparentspinner";

const ExpiredSubscriptionTable = () => {
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loading, setLoading] = useState(false);

  const [isIndustry, setIsIndustry] = useState("");
  const [isCompany, setIsCompany] = useState("");

  const [searchResetKey, setSearchResetKey] = useState(0);

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [appliedFilters, setAppliedFilters] = useState({});

  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
    expiredSubscriptionData(1);
  }, []);

  useEffect(() => {
    setIsCompany(null);
  }, [isIndustry]);

  const OrderHistoryColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Si,
      width: "80px",
      center: true,
    },
    {
      name: <H4>User Name</H4>,
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.UserId}`}
        >
          {row.UserName}
        </Link>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <H4>Invoice No</H4>,
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?order_id=${row.OrderId}`}
        >
          {row.InvoiceNo}
        </Link>
      ),
      sortable: true,
      wrap: true,
      width: "140px",
    },
    {
      name: <H4>Industry Name</H4>,
      selector: (row) => row.IndustryName,
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: <H4>Company Name</H4>,
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.company_id}&user_id=${row.Id}&industryId=${row.industryTypeId}`}
          state={{
            clientUrl: row.ClientUrl,
            industryName: row.IndustryName,
          }}
        >
          {row.CompanyName}
        </Link>
      ),
      sortable: true,
      width: "190px",
      wrap: true,
    },
    {
      name: <H4>Amount</H4>,
      selector: (row) => row.Amount,
      sortable: true,
      width: "120px",
      cell: (row) => `$${row.Amount}`,
    },
    {
      name: <H4>Invoice Date</H4>,
      selector: (row) => row.InvoiceDate,
      sortable: true,
      width: "150px",
    },
  ];

  const updateSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
  };

  const handleFilter = () => {
    const filters = {
      industry_type_id: isIndustry?.value || "",
      company_id: isCompany?.value || "",
      start_date: startDate ? startDate.toISOString().split("T")[0] : "",
      end_date: endDate ? endDate.toISOString().split("T")[0] : "",
      search: searchKeyword,
    };

    setAppliedFilters(filters);
    setCurrentPage(1);

    expiredSubscriptionData(1, perPage, filters);
  };

  const ResetFileter = () => {
    setIsCompany(null);
    setIsIndustry(null);

    setDateRange([null, null]);

    setSearchResetKey((prev) => prev + 1);

    setAppliedFilters({
      industry_type_id: "",
      company_id: "",
      start_date: "",
      end_date: "",
      search: "",
    });
    setCurrentPage(1);

    expiredSubscriptionData(1, perPage, {});
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);

    expiredSubscriptionData(page, perPage, appliedFilters);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);

    expiredSubscriptionData(page, newPerPage, appliedFilters);
  };

  const expiredSubscriptionData = async (
    page = 1,
    size = perPage,
    filters = appliedFilters,
  ) => {
    try {
      setLoading(true);

      const query = new URLSearchParams({
        page,
        page_length: size,
        search: filters.search || "",
        industry_type_id: filters.industry_type_id || "",
        company_id: filters.company_id || "",
        start_date: filters.start_date || "",
        end_date: filters.end_date || "",
      }).toString();

      const res = await getDataWithToken(`${getExpireSub}?${query}`);

      const list = res?.data?.data || [];

      setTotalRows(res?.data?.total || list.length);

      const mappedData = list.map((e, index) => ({
        Si: (page - 1) * size + index + 1,

        UserId: e.user_id,

        CompanyId: e.company_id,

        IndustryTypeId: e.industry_type_id,

        UserName: e.user_name,

        InvoiceNo: e.invoice_number,

        IndustryName: e.industry_type_name,

        CompanyName: e.company,

        ClientUrl:e.client_url,

        Amount: e.amount,

        InvoiceDate: e.invoice_date,

        OrderId: e.order_id,
      }));

      setSubscriptionList(mappedData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs
        mainTitle="Expired Subscription"
        parent="Subscription"
        title="Expired Subscription"
      />

      <Card>
        <CardHeader>
          <H3>Expired Subscription List</H3>
        </CardHeader>

        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>

              <Col sm="12" md="5" lg="3">
                <div style={{ position: "relative" }}>
                  <DatePicker
                    className="form-control digits w-100"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    isClearable={!!(startDate || endDate)}
                    monthsShown={2}
                    calendarClassName="parallel-calendar"
                    placeholderText="Select Date Range"
                    dateFormat="dd-MM-yyyy"
                  />
                </div>
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>

              <Col sm="12" md="5" lg="3">
                <CompanyFilter
                  IsCompany={isCompany}
                  setIsCompany={setIsCompany}
                  industryId={isIndustry?.value}
                />
              </Col>

              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    float: "left",
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-primary mb-2 ms-2"
                    onClick={handleFilter}
                  >
                    Filter
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary mb-2"
                    onClick={ResetFileter}
                  >
                    Reset
                  </button>
                </div>
              </Col>
            </Row>
          </div>
          <div style={{ clear: "both" }}></div>
        </div>

        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={OrderHistoryColumns}
              data={subscriptionList}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              progressPending={loading}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default ExpiredSubscriptionTable;
